import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalpopService } from '../modalpop.service';
import { MatDialogRef } from '@angular/material/dialog';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment'; 
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
@Component({
  selector: 'app-report-course',
  templateUrl: './report-course.component.html',
  styleUrls: ['./report-course.component.scss']
})
export class ReportCourseComponent implements OnInit {

  CourseRep: FormGroup;
  dialogRef: MatDialogRef<any>;
  Course1 = false;
  Course2 = false;
  Branch = false;
  Clg = false;
  Centre = false;
  Dist = false;
  Regno = false;
  NtAssgn = false;
  Town = false;
  Radio1 = false;
  Radio2 = false;
  Radio3 = false;
  APIService: any;
  filteredDataList: any;
  DataList: any;
  RGInCode = 0;
  G_Regn_Roll = '';
  SessionLabel;
  TitleOne = 'titleOne';
  RegnNo = "RegnNo";
  Radio1Label = "Convo";
  Radio2Label = "Merit";
  CourseList: any;
  filteredListCourse: any;
  BranchList: any;
  filteredListBranch: any;
  RptTime: any;
  rptCode: any;
  spName: any;
  RptType: any;
  RptImg: any;
  submitpayload: any;
  PgBreak: string;
  collegeList: any;
  filteredListCollege: any;
  filteredListCourse1: any;
  CourseList1: any;
  stucourseClgMapList: any;
  filteredstucourseClgMapListList: any;
  SessionNo: any;
  RollNo: any;
  RgNo: string;
  constructor(public umsService: UmsService,private spinner:NgxSpinnerService,
    private location: Location,
    private modalPopupService: ModalpopService, private httpClient: HttpClient,
    private route: ActivatedRoute,public router: Router,
    public fb: FormBuilder) {  this.APIService = environment.serviceUrl;  }

  ngOnInit(): void {
    if(JSON.parse(sessionStorage.getItem("session")) == null){
      this.fetchSecretData();
    }
    else if(JSON.parse(sessionStorage.getItem("session")) != null){
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo;
      this.SessionLabel = sessionData.SnName;
    }
    // this.SessionLabel = this.umsService.secretdata['SnName'];
    this.route.queryParams.subscribe((params) => {
      this.RGInCode = params['MenuCode'];
      // this.loadpage(this.RGInCode);
      this.repDetails(this.RGInCode);
      this.CourseRep = this.fb.group({
        Course: new FormControl(''),
        Branch: new FormControl(''),
        College: new FormControl(''),
        Radio1: new FormControl(''),
        Radio2: new FormControl(''),
        Centre: new FormControl(''),
        Summ: new FormControl(''),
        Dist: new FormControl(''),
        RegnNo: new FormControl(''),
        NoAssgn: new FormControl('')
       } );
       
       this.getCollegeData();
    });
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
      this.SessionLabel = res.projectPharam['SnName'];
      }
    );
  }

  repDetails(id) {
    const payload = {};
    payload['RptTime'] = '';
    payload['RptCode'] = id;
    this.umsService.reportDetails(payload).subscribe(res => {
      if (res.status) {
        
        let data = res.data[0];
        this.TitleOne = data['RptName']
        this.RptTime = data['RptTime']
        this.rptCode = data['RptCode']
        this.spName = data['RptProc']
        this.RptType = data['RptType']
        this.RptImg = data['RptImg']

        this.loadpage(data['RptCode'],data['RptParam'])
      }
    });
  }

  loadpage(rptCode, rptParam){
    this.Course1 = true;
    this.Course2 = false;
    let params = []
    params = rptParam.split(',')
    params.forEach(element => {
      switch (element) {
        case "CgCode":
          this.Clg = true;
          break;
          case "Cent":
            this.Centre = true;
          case "TnCode": 
            this.Town = true;
          case "BR":
            this.Branch = true;
          case "RollNo":
            this.Regno = true;
            this.RegnNo = 'Roll No'
          case "Ds":
            this.Dist = true;
      }})

      if(rptCode == 40){
        this.NtAssgn = true;
        this.Branch = false;
        this.Town = false;
        this.Regno = false;

      }
      else if(rptCode == 52){
        this.Course1 = true;
        this.Course2 = false;
        this.NtAssgn = false;
        this.Branch = false;
        this.Town = false;
        this.Regno = false;
        this.Dist = false;
      }
      else if(rptCode == 51){
        this.Branch = false;
        this.Regno = false;
      }
      else if(rptCode == 56){
        this.Dist = false;
      }

      if(rptCode == 53 && this.umsService.secretdata['ClubPartTrans'] == 11){
        this.Radio1 = true;
        this.Radio2 = true;
        this.Radio3 = true;
        this.Radio1Label = "Convo"
        this.Radio2Label = "Merit"
      }
      else if(rptCode == 62 && this.umsService.secretdata['ClubPartTrans'] == 6){
        this.Radio1 = true;
        this.Radio2 = true;
        this.Radio1Label = "Course";
        this.Radio2Label = "Exam"
      }

      if(rptCode == 65){
        this.Course1 = false;
        this.Course2 = true;
        const payload = {};
        payload['SnNo'] = this.SessionNo;
        this.umsService.SrchCoUpdt(payload).subscribe(res => {
          if (res.status) {
            this.CourseList1 = res.data;
            this.filteredListCourse1 = this.CourseList1.slice();
          }
        });
      }
      else{
        const payload = {};
        payload['LoginId'] = 0;
        this.umsService.getCourse(payload).subscribe(res => {
          if (res.status) {
            this.CourseList = res.data;
            this.filteredListCourse = this.CourseList.slice();
          }
        });
      }
      
      
  }

  getCollegeData() {
    this.spinner.show();
    const payload = {};
     payload['PageSize'] = '';
    payload['PageNumber'] = '';
    this.umsService.getCollege(payload).subscribe((res) => {
      this.collegeList = res.data;
      this.filteredListCollege = this.collegeList.slice();
      this.spinner.hide();
    },(ERROR: HttpErrorResponse) => {
      this.collegeList = [];
      this.spinner.hide();
    })
    // this.spinner.show();
    // const payload = {};
    // payload['EmId'] = item.ShEmId;
    // this.umsService.getExamCollegeForReport(payload).subscribe((res) => {
    //   this.spinner.hide();
    //   this.collegeList = res.data;
    //   this.filteredListCollege = this.collegeList.slice();
    // })

  }

  getBr(CoCode){
    this.getCourseWiseCollege(CoCode)
    if(this.Branch == true){
      const payload = {};
      payload['CoCode'] = CoCode
      payload['EmId'] = 0;
      this.umsService.getExamStream(payload).subscribe(res => {
        if (res.status) {
          this.BranchList = res.data;
          this.filteredListBranch = this.BranchList.slice();
        }
      });
    }
  }


  Print(){
    this.submitpayload = this.CourseRep.value
    if(this.rptCode != 51 || this.rptCode != 52 || this.rptCode != 59 || this.rptCode != 62){
      if(this.submitpayload['Course'] == ''){
        let data = {}
        data['message'] = "Course Required"
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    }

    if(this.umsService.secretdata['ClubPartTrans'] == 11 && this.rptCode == 52){
      if(this.submitpayload['Radio1'] == 'true'){
        this.PgBreak = 'C';
      }
      else if(this.submitpayload['Radio1'] == '' && this.submitpayload['Radio2'] == 'true'){
        this.PgBreak = 'M';
      }
      else{
        this.PgBreak = 'S';
      }
    }

    if(this.umsService.secretdata['ClubPartTrans'] == 6 && this.rptCode == 62){
      if(this.submitpayload['Radio2'] == 'true'){
        this.PgBreak = 'E'
      }
      else if(this.submitpayload['Radio2'] == ''){
        this.PgBreak = '';
      }
    }
    
    if(this.submitpayload['NoAssgn'] == 1){
      this.submitpayload['RegnNo'] = '?';
    }
    else{
      this.submitpayload['RegnNo'] = this.submitpayload['RegnNo']
    }

    var filter: any;
    if(this.RegnNo = 'Roll No'){
      this.RollNo = this.submitpayload['RegnNo'] ? this.submitpayload['RegnNo'] : 0;
      this.RgNo = ''
    }
    else if(this.RegnNo = 'RegnNo'){
      this.RollNo = 0;
      this.RgNo = this.submitpayload['RegnNo'] ? this.submitpayload['RegnNo'] : 0;
    }
    filter = {
      "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
      "RptCode": this.rptCode,
      "InstName": '',
      "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
      "ShId": this.submitpayload['Exam'] ? this.submitpayload['Exam'] : '',
      "CgCode": this.submitpayload['College'] ? this.submitpayload['College'] : '',
      "RollNo": this.RollNo,
      "Cent": this.submitpayload['Flag'] ? this.submitpayload['Flag'] : 0,
      "TnCode": this.submitpayload['ZnTn'] ? this.submitpayload['ZnTn'] : 0,
      "EsId":  this.submitpayload['Subject'] ? this.submitpayload['Subject'] : 0,
      "CsNo": '',
      "PgBreak": '',
      "StrId":this.submitpayload['Branch'] ? this.submitpayload['Branch'] : 0,
      "StrCode": '',
      "RgNo": this.RgNo,
      "UC": this.submitpayload['UniClg'] ?  this.submitpayload['UniClg'] : 0,
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": this.submitpayload['District'] ? this.submitpayload['District'] : '',
      "CoCode": this.submitpayload['Course'] ? this.submitpayload['Course'] : '',
      "SnNo": this.SessionNo,
      "Extra1":'',
    }
    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.redirect('reports')

  }

  redirect(to): void {
    this.router.navigate([to]);
  }


  getCourseWiseCollege(id){
    this.spinner.show();
    const payload = {};
    payload['CoCode'] = id;
    this.filteredstucourseClgMapListList = [];
    this.umsService.fetchstucourseClgMap(payload).subscribe(res => {
      this.spinner.hide()
      this.stucourseClgMapList = res.data;
      this.filteredstucourseClgMapListList = this.stucourseClgMapList.slice();
      // this.dataSource = new MatTableDataSource(this.facultyList);
    });
  }

  Back(){
    this.goBack();
   }
   goBack(): void {
    this.location.back(); // This will navigate back to the previous page
  }
}
